import React from 'react';
import { ButtonProps } from '../../../../components/menus/buttons/types';
import EditorAlignLeft from '@wix/da-ds/pkg/Icons/24x24/EditorAlignLeft';
import EditorAlignRight from '@wix/da-ds/pkg/Icons/24x24/EditorAlignRight';
import EditorAlignCenter from '@wix/da-ds/pkg/Icons/24x24/EditorAlignCenter';
import { useTranslation } from 'react-i18next';
import EditorIconButtonWithContextMenu from '../../../../components/menus/_partials/EditorIconButtonWithContextMenu';

const Alignment: React.FC<ButtonProps> = ({ editor }) => {
  const { t } = useTranslation('editor');
  let CurrentIcon = EditorAlignLeft;
  if (editor.isActive('da-video', { alignment: 'right' })) {
    CurrentIcon = EditorAlignRight;
  }
  if (editor.isActive('da-video', { alignment: 'center' })) {
    CurrentIcon = EditorAlignCenter;
  }
  if (!editor.can().chain().focus().daVideoAlign('center').run()) {
    return null;
  }
  return (
    <EditorIconButtonWithContextMenu
      featureId="node:video:align"
      aria-label={t('ext.video.button.alignment')}
      tooltipText={t('ext.video.button.alignment')}
      icon={CurrentIcon}
      items={[
        {
          featureId: 'node:video:alignLeft',
          label: 'Left',
          icon: <EditorAlignLeft />,
          selected: editor.isActive('da-video', { alignment: 'left' }),
          onClick: () => {
            editor.chain().focus().daVideoAlign('left').run();
          },
        },
        {
          featureId: 'node:video:alignCenter',
          label: 'Center',
          icon: <EditorAlignCenter />,
          selected: editor.isActive('da-video', { alignment: 'center' }),
          onClick: () => {
            editor.chain().focus().daVideoAlign('center').run();
          },
        },
        {
          featureId: 'node:video:alignRight',
          label: 'Right',
          icon: <EditorAlignRight />,
          selected: editor.isActive('da-video', { alignment: 'right' }),
          onClick: () => {
            editor.chain().focus().daVideoAlign('right').run();
          },
        },
      ]}
    />
  );
};
Alignment.displayName = 'Alignment';

export default Alignment;
